import { GoldLine } from '@/components/ornaments';
import { Reveal } from '@/components/motion';
import { IconFeature } from '@/components/ui';
import { DisplayTitle, Prose } from '@/components/typography';
import { AssetImage } from '@/pages/shared/AssetImage';
import { CHAMBER } from '../hub.content';
import styles from './HubChamber.module.css';

/**
 * La Cámara Cuántica Pleyadiana: el producto estrella de la gira.
 *
 * `IconFeature` come un `Benefit` del dominio de eventos. Aqui los 4 rasgos no
 * pertenecen a ningun destino (son de la experiencia en si), asi que se
 * construyen desde el copy del hub — pero con la MISMA forma de dato, para que
 * el dia que quieran vivir en la config no haya que tocar el marcado.
 */
export function HubChamber() {
  return (
    <section className={styles.chamber} id="experiencia" aria-labelledby="hub-camara-title">
      {/* SIN `Container`, y es el arreglo de fidelidad de esta seccion: en el
          poster la foto de la Camara SANGRA por el borde izquierdo (empieza en
          x=0) y llega arriba y abajo de la banda. Metida en un contenedor centrado
          arrancaba en x=40 con aire por los cuatro lados y la banda se leia como
          una tarjeta ancha, no como el corte a sangre del mockup.
          El aire ahora lo pone la COLUMNA DE TEXTO, no la seccion. */}
      <div className={styles.grid}>
        <Reveal className={styles.media}>
          <AssetImage
            asset="hub/camara-cuantica"
            className={styles.mediaFrame}
            sizes="(min-width: 768px) 54vw, 100vw"
            alt={CHAMBER.imageAlt}
          />
        </Reveal>

        <div className={styles.copy}>
          <Reveal>
            <DisplayTitle
              id="hub-camara-title"
              level={2}
              size="md"
              align="center"
              uppercase
              className={styles.title}
            >
              {/* Las DOS lineas del poster. El `<br>` ya estaba, pero la segunda
                    («CUÁNTICA PLEYADIANA») no cabia en la columna y se partia otra
                    vez: salian TRES lineas. Se cierra en el CSS con el cuerpo
                    medido, no rebajando el contenido. */}
              {CHAMBER.titleLines[0]}
              <br />
              <span className={styles.titleLine}>{CHAMBER.titleLines[1]}</span>
            </DisplayTitle>
          </Reveal>

          <Reveal delay={0.06}>
            <GoldLine ornament="star" width="sm" />
          </Reveal>

          <Reveal delay={0.12}>
            <Prose align="center" size="sm" className={styles.paragraph}>
              {CHAMBER.paragraph}
            </Prose>
          </Reveal>

          <ul className={styles.features} role="list">
            {CHAMBER.features.map((feature, index) => (
              <Reveal as="li" className={styles.feature} delay={0.16 + index * 0.06} key={feature.id}>
                <IconFeature
                  benefit={{
                    id: feature.id,
                    icon: feature.icon,
                    title: feature.title,
                    description: null,
                  }}
                  layout="column"
                />
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
